'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var solveSimultaneousEquations = exports.solveSimultaneousEquations = function solveSimultaneousEquations(a, b, c, d, e, f) {
  // Solve system of equations ax + by = e and cx + dy = f
  var det = a * d - b * c;
  var x = (d * e - b * f) / det;
  var y = (a * f - c * e) / det;
  return { x: x, y: y };
};

var getProjectionFromPointToLine = exports.getProjectionFromPointToLine = function getProjectionFromPointToLine(point, line) {
  // Get projection from point (x, y) to a line ax + by + c = 0
  var projection = solveSimultaneousEquations(line[0], line[1], -line[1], line[0], -line[2], line[0] * point.y - line[1] * point.x);
  return projection;
};

var getDistanceFromPointToLine = exports.getDistanceFromPointToLine = function getDistanceFromPointToLine(point, line) {
  return Math.abs(line[0] * point.x + line[1] * point.y + line[2]) / Math.sqrt(line[0] * line[0] + line[1] * line[1]);
};

var getClosestLine = exports.getClosestLine = function getClosestLine(currentPoint, lastPoint) {
  // 4 base line in plane, horizontal, vertical, 45 degree, 135 degree
  // each line formulation ax + by + c = 0 -> [a, b, c]
  var lineList = [[1, 1, -1 * (lastPoint.x + lastPoint.y)], [1, -1, -1 * (lastPoint.x - lastPoint.y)], [1, 0, -lastPoint.x], [0, 1, -lastPoint.y]];

  var distance = lineList.map(function (line) {
    return getDistanceFromPointToLine(currentPoint, line);
  });
  var maxDistance = Math.min.apply(Math, _toConsumableArray(distance));
  var maxIndex = distance.indexOf(maxDistance);
  return lineList[maxIndex];
};

var calculateVerticalAndHorizontalLine = exports.calculateVerticalAndHorizontalLine = function calculateVerticalAndHorizontalLine(currentPoint, lastPoint) {
  // simple calculation when we only want to lock 0, 90, 180, 270, 360 degree
  var xDistance = Math.abs(currentPoint.x - lastPoint.x);
  var yDistance = Math.abs(currentPoint.y - lastPoint.y);
  if (xDistance > yDistance) {
    return {
      x: currentPoint.x,
      y: lastPoint.y
    };
  } else {
    return {
      x: lastPoint.x,
      y: currentPoint.y
    };
  }
};

var solveEquationX = function solveEquationX(line, yValue) {
  // Find x when know y, equation line[0]x + line[1]y + line[2] = 0
  if (line[0] === 0) {
    throw new Error('There are infinite number of solutions');
  }
  return -1 * (line[1] * yValue + line[2]) / line[0];
};

var solveEquationY = function solveEquationY(line, xValue) {
  // Find y when know x, equation line[0]x + line[1]y + line[2] = 0
  if (line[1] === 0) {
    throw new Error('There are infinite number of solutions');
  }
  return -1 * (line[0] * xValue + line[2]) / line[1];
};

var checkBoundary = exports.checkBoundary = function checkBoundary(point, boundary, line) {
  /**
   * If point is outside of boundary, return intersection between line and boundary
   */
  if (point.x < boundary.minX) {
    point.x = boundary.minX;
    point.y = solveEquationY(line, boundary.minX);
  } else if (point.x > boundary.maxX) {
    point.x = boundary.maxX;
    point.y = solveEquationY(line, boundary.maxX);
  }

  if (point.y < boundary.minY) {
    point.y = boundary.minY;
    point.x = solveEquationX(line, boundary.minY);
  } else if (point.y > boundary.maxY) {
    point.y = boundary.maxY;
    point.x = solveEquationX(line, boundary.maxY);
  }
  return point;
};

var calculateNearestPoint = exports.calculateNearestPoint = function calculateNearestPoint(currentPoint, lastPoint) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var nearestLine = getClosestLine(currentPoint, lastPoint);
  var result = getProjectionFromPointToLine(currentPoint, nearestLine);
  var boundary = config.boundary;
  if (boundary) {
    result = checkBoundary(result, boundary, nearestLine);
  }
  return result;
};

var calculatePosition = exports.calculatePosition = function calculatePosition(currentPoint, lastPoint) {
  var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!lastPoint || !currentPoint) {
    return null;
  }
  if (config.isSimple) {
    // only lock 0, 90, 180, 270, 360 degree
    return calculateVerticalAndHorizontalLine(currentPoint, lastPoint);
  } else {
    // lock 0, 45, 90, 135... degree
    return calculateNearestPoint(currentPoint, lastPoint, config);
  }
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/draw-lock-angle/dist/src/libs/helper.js
 ** module id = 203
 ** module chunks = 0
 **/